import Footer from "../components/footer";
import Navbar from "../components/navbar";
import PriPolicy from "../components/privacy_policy"

function PrivacyPolicy(){
    return(
<>
        <Navbar/>
        <PriPolicy/>
        <Footer/>

</>        
    )
}
export default PrivacyPolicy;